// M-7 slice A: global search API + recent-query persistence (CloudStorage).
import { apiRequest } from './client'
import { MOCK, mockSearch } from '../dev/mock'
import { tgStorage } from '../telegram/tg'
import type { SearchResponse } from './types'

export function fetchSearch(q: string, limit = 5): Promise<SearchResponse> {
  if (MOCK) {
    // Filter the fixtures so the demo reacts to the query.
    const needle = q.trim().toLowerCase()
    const id = needle.replace(/[^\d]/g, '')
    const hit = (s: string) => s.toLowerCase().includes(needle)
    return Promise.resolve({
      deals: mockSearch.deals.filter((d) => hit(d.client_name) || String(d.id).includes(id)),
      tasks: mockSearch.tasks.filter((t) => hit(t.title) || String(t.deal_id).includes(id)),
      clients: mockSearch.clients.filter((c) => hit(c.name)),
    })
  }
  const qs = new URLSearchParams({ q, limit: String(limit) })
  return apiRequest<SearchResponse>(`/api/miniapp/search?${qs.toString()}`)
}

// ── recent queries (top-5, CloudStorage) ────────────────────────────────────

const RECENT_KEY = 'recent_searches'
const RECENT_MAX = 5

export async function getRecentSearches(): Promise<string[]> {
  try {
    const raw = await tgStorage.get(RECENT_KEY)
    const arr = raw ? JSON.parse(raw) : []
    return Array.isArray(arr) ? arr.filter((x) => typeof x === 'string').slice(0, RECENT_MAX) : []
  } catch {
    return []
  }
}

export async function pushRecentSearch(q: string): Promise<void> {
  const v = q.trim()
  if (v.length < 2) return
  try {
    const cur = await getRecentSearches()
    const next = [v, ...cur.filter((x) => x.toLowerCase() !== v.toLowerCase())].slice(0, RECENT_MAX)
    await tgStorage.set(RECENT_KEY, JSON.stringify(next))
  } catch {
    /* best-effort */
  }
}
